import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationToastService } from '../../../../services/notification-toast.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MenuService } from '../../../../services/menu.service';
import { CashDeskService } from '../../../../services/cash-desk.service';
import { FilterCompleteService, IFilterComplete } from '../../../../filter-complete/filter-complete';
import { MatTableDataSource, MatDialog } from '@angular/material';
import { CashDeskManualSearchItem } from '../../../../model/cash-desk-manual-search-item';
import { AuthService } from '../../../../services/auth.service';
import { CashDeskManualAssociationViewDialogComponent } from '../../../dialogs/cash-desk-manual-association-view/cash-desk-manual-association-view-dialog.component';
import { InvoiceCashDeskAssociationInfo } from '../../../../model/invoice-cash-desk-association-info';
import { ConfirmDialogService } from '../../../../services/confirm-dialog.service';
import { Observable } from 'rxjs/internal/Observable';

@Component({
  selector: 'cash-desk-manual-association',
  templateUrl: './cash-desk-manual-association.component.html',
  styleUrls: ['./cash-desk-manual-association.component.css']
})
export class CashDeskManualAssociationComponent implements OnInit {

  form: FormGroup;
  loading: boolean;
  cashDeskManualSearchItems: CashDeskManualSearchItem[] = [];
  displayedColumns: string[] = ['Number', 'BusinessName', 'CreateDateView', 'Amount', 'RemainingBalance', 'Star'];
  dataSource = new MatTableDataSource([]);
  invoiceCashDeskAssociationInfo: InvoiceCashDeskAssociationInfo;
  medicalAppointmentId: number;

  constructor(private route: ActivatedRoute
    , private menuService: MenuService
    , private formBuilder: FormBuilder
    , private cashDeskService: CashDeskService
    , private authService: AuthService
    , private dialog: MatDialog
    , private router: Router
    , private confirmDialogService: ConfirmDialogService
    , private notificationToastService: NotificationToastService) {
    this.menuService.setMenuTitle('Cobranza', 'Saldo con factura anticipo');
    this.form = this.formBuilder.group({
      Number: [''],
      BusinessName: ['']
    });
  }

  async ngOnInit() {
    this.route.params.subscribe(params => {
      try {
        this.medicalAppointmentId = params['MedicalAppointmentId'];
        this.cashDeskService.getInvoiceCashDeskAssociationInfo(this.medicalAppointmentId).then((info) => {
          this.invoiceCashDeskAssociationInfo = info;
        }, (err) => { this.notificationToastService.error(JSON.stringify(err.error), 'Cobranza'); });
      } catch (err) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Cobranza');
      }
    });
  }

  close(): void {
    this.router.navigate(['pending-cash-desk-search']);
  }

  associate(item: CashDeskManualSearchItem): void {

    if (item.RemainingBalance > 0) {
      const dialogRef = this.dialog.open(CashDeskManualAssociationViewDialogComponent, {
        width: '90%',
        height: '600px',
        data: item
      });

      dialogRef.afterClosed().subscribe(async (result: boolean) => {
        if (result) {

          let text = ' ';
          if (this.invoiceCashDeskAssociationInfo && this.invoiceCashDeskAssociationInfo.Amount !== item.Amount) {
            text += 'El monto total no coincide.';
          }
          if (this.invoiceCashDeskAssociationInfo && this.invoiceCashDeskAssociationInfo.PosibleInvoicePointId !== item.InvoicePointId) {
            text += ' El punto de venta no conicide.';
          }
          text += ' Usted está seguro que desea asociar la cobranza?';

          this.confirmDialogService.confirm('Cobranza', text, 'Asociar', 'Cancelar').subscribe(async (confirm) => {
            if (confirm) {
              try {
                this.loading = true;
                await this.cashDeskService.invoiceCashDeskAssociate(item.Id, this.medicalAppointmentId);
                this.router.navigate(['pending-cash-desk-search']);
              } catch (err) {
                this.notificationToastService.error(JSON.stringify(err.error), 'Cobranza');
              } finally {
                this.loading = false;
              }
            }
          });
        }
      });
    } else {
      this.notificationToastService.error('No se dispone de saldo en esta factura', 'Cobranza manual');
    }
  }

  async search() {
    try {
      if (this.form.controls.BusinessName.value || this.form.controls.Number.value) {
        this.loading = true;
        this.cashDeskManualSearchItems =
        await this.cashDeskService.getCashDeskManualSearchItemForAssociateInvoices(
          this.authService.getCompanyIds(),
          this.form.controls.BusinessName.value,
          !this.invoiceCashDeskAssociationInfo.AllowRemainingBalanceAssociation,
          this.form.controls.Number.value);
        this.dataSource = new MatTableDataSource(this.cashDeskManualSearchItems);
      } else {
        this.notificationToastService.error('Debe ingresar algún criterio de búsqueda', 'Cobranza manual');
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Cobranza');
    } finally {
      this.loading = false;
    }
  }



}
